import Link from 'next/link';
import { getAppLinks } from '../util/appLinks';
const appLinks = getAppLinks();

const Index = () => {
  return (
    <>
      <h1>CarbonClick Calculators</h1>
      <ul>
        <li>
          <Link href={appLinks.calculatorWidget}>Calculator Widget</Link>
        </li>
        <li>
          <Link href={appLinks.businessEmissions}>Business Emissions</Link>
        </li>
        <li>
          <div onClick={()=>{localStorage.clear();alert('cleared')}}>Clear storage</div>
        </li>
        <li>
          <a href="pre-defined-data-travelV1.html">TravelV1 data</a>
        </li>
      </ul>
    </>
  );
};

export default Index;
